<template>
    <div class="" >
        <div class="dx-field">
            <div class="dx-field-value" :style="{width: data.width + 'px'}">
                <DxTextBox 
                    readOnly
                    :placeholder="placeholder" 
                    :value="value"/>
            </div>
            <div>
                <DxButton text="" styling-mode="text" icon="remove" @click="clearValue" />
                <DxButton text="" styling-mode="text" icon="checklist" @click="onClick"/>
            </div>
        </div>
    </div>
</template>

<script setup>

import { toRef, defineProps, provide } from 'vue';
import DxTextBox from 'devextreme-vue/text-box';
import DxButton from 'devextreme-vue/button';


const props = defineProps({
    placeholder: String,
    value: String,
    // данные карточки, в 90% случаев предполагается
    // что карточка ожидает получить store.state.userDataDetails.userData.data
    data: {
        type: Object,
        default: () => {
            return {
                value: '',
                placeholderValue: '',
                width: 200,
                onClick: null
            }
        },
    },
    id: null,
});

const data = toRef(props, 'data');
provide('data', data);
// inject('data');

const clearValue = () => {
    data.value.value = null;
}

const onClick = () => {
    if(data.value.onClick){
        data.value.value = data.value.onClick();
    }
}

</script>

<style scoped>

.dx-field{
    align-items: baseline;
    padding-left: 32px;
}
</style>